import { AfterViewInit, Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MoveModalSandbox } from '@app/move/sandboxes/move-modal.sandbox';
import { MoveSandbox } from '@app/move/sandboxes/move.sandbox';
import { BoilerMaintenanceService } from '@app/services/boiler-maintenance/services/boiler-maintenance.service';
import { ServicesSandbox } from '@app/services/sandboxes/services.sandbox';
import { PosthogService } from '@app/tracking/posthog.service';
import { AppUiSandbox } from '@app/ui/sandboxes/ui.sandbox';
import { environment } from '@environments/environment';
import { PostHogEventsEnum, StringUtils, UrlUtils } from '@smooved/core';
import { combineLatest, Observable } from 'rxjs';
import { filter, map, switchMap, tap } from 'rxjs/operators';

const showMeterReadingsEnergy = 'showMeterReadingsEnergy';

@Component({
    selector: 'app-dashboard-container',
    template: `
        <ng-container *ngIf="{ move: (moveSandbox.move$ | async) } as vm">
            <div [style.padding-bottom]="paddingBottom$ | async">
                <app-dashboard-services></app-dashboard-services>
                <app-shopping-cart *ngIf="moveSandbox.showShoppingCart$ | async"></app-shopping-cart>
            </div>
            <app-trigger-webhook *ngIf="showTestWebhook"></app-trigger-webhook>
        </ng-container>
    `,
    styleUrls: ['./dashboard.container.scss'],
})
export class DashboardContainer implements AfterViewInit, OnInit {
    private readonly posthogService = inject(PosthogService);

    public showTestWebhook = environment.showTestWebhook;

    public paddingBottom$: Observable<string> = combineLatest(
        this.moveSandbox.showShoppingCart$,
        this.uiSandbox.upToAndIncludingPhoneLandscape$,
    ).pipe(
        map(([showShoppingCart, upToAndIncludingPhoneLandscape]) => {
            if (!showShoppingCart) {
                return '0';
            }
            return upToAndIncludingPhoneLandscape ? '200px' : '150px';
        }),
    );

    constructor(
        public readonly moveSandbox: MoveSandbox,
        private readonly uiSandbox: AppUiSandbox,
        private readonly moveModalSandbox: MoveModalSandbox,
        private readonly activatedRoute: ActivatedRoute,
        private readonly boilerMaintenanceService: BoilerMaintenanceService,
        private readonly servicesSandbox: ServicesSandbox,
    ) {}

    public ngOnInit(): void {
        this.posthogService.sendEventForTransactionState(PostHogEventsEnum.ViewDashboard);
    }

    public ngAfterViewInit(): void {
        if (StringUtils.parseBoolean(this.activatedRoute.snapshot.queryParamMap.get(showMeterReadingsEnergy))) {
            this.moveModalSandbox.showMeterReadingsEnergy();
        }
        this.moveSandbox.idOnce$
            .pipe(
                filter((id) => !!id),
                switchMap((transactionId) => this.boilerMaintenanceService.getContract(transactionId)),
                tap((boilerMaintenanceContract) => {
                    this.servicesSandbox.setOrderedBoilerMaintenanceContract(boilerMaintenanceContract);
                }),
            )
            .subscribe();
        const newUrl = UrlUtils.removeUrlQueryParameters(location.href, [showMeterReadingsEnergy]);
        UrlUtils.replaceState(newUrl.href);
    }
}
